import React from 'react'
import env from './../../environments/environment'
import appConstants from './../../constants/appConstants'
import { isWhiteLabel } from './../../shared/utilities/whiteLabel.function'

import './SocialMediaLinks.scss'

const SocialMediaLinks = props => {
  if (isWhiteLabel()) return null

  return (
    <div className='SocialMediaLinksComponent'>
      {(typeof appConstants?.social_media === 'object' ? Object.values(appConstants.social_media) : []).map(
        (social, idx) => (
          <React.Fragment key={`header-social-btn-${social.name.replace(/\s/g, '')}`}>
            <div className='social-btn'>
              <a href={social.link} rel='noopener noreferrer' target='_blank'>
                <img
                  alt={`${social.name}`}
                  src={`https://firebasestorage.googleapis.com/v0/b/${
                    social.bucket || env.integrations.firebase.config.storageBucket
                  }/o/static%2F${social.icon}?alt=media`}
                  title={`${social.name}`}
                  className='social-icon rounded'
                />
              </a>
            </div>
            {idx === 3 && <div className='line-break'></div>}
          </React.Fragment>
        )
      )}
    </div>
  )
}

export default SocialMediaLinks
